/**
 * Curl 转换器示例数据
 * 包含各种常见的 curl 命令示例
 */

export const examples = [
  {
    id: 'simple-get',
    title: '简单 GET 请求',
    description: '获取 API 数据',
    command: 'curl https://api.github.com/users/octocat',
    category: 'basic',
    icon: '📥'
  },
  {
    id: 'post-json',
    title: 'POST JSON 数据',
    description: '发送 JSON 数据到 API',
    command: 'curl -X POST -H "Content-Type: application/json" -d \'{"name": "John", "age": 30}\' https://api.example.com/users',
    category: 'data',
    icon: '📤'
  },
  {
    id: 'auth-bearer',
    title: 'Bearer Token 认证',
    description: '使用 Bearer Token 进行认证',
    command: 'curl -H "Authorization: Bearer your-token-here" https://api.example.com/protected',
    category: 'auth',
    icon: '🔐'
  },
  {
    id: 'basic-auth',
    title: '基本认证',
    description: '使用用户名和密码进行基本认证',
    command: 'curl -u username:password https://api.example.com/secure',
    category: 'auth',
    icon: '👤'
  },
  {
    id: 'form-upload',
    title: '文件上传',
    description: '上传文件到服务器',
    command: 'curl -X POST -F "file=@document.pdf" -F "description=Important document" https://api.example.com/upload',
    category: 'upload',
    icon: '📎'
  },
  {
    id: 'custom-headers',
    title: '自定义请求头',
    description: '添加多个自定义请求头',
    command: 'curl -H "User-Agent: MyApp/1.0" -H "Accept: application/json" -H "X-API-Key: secret" https://api.example.com/data',
    category: 'headers',
    icon: '🏷️'
  },
  {
    id: 'query-params',
    title: '查询参数',
    description: '发送带查询参数的请求',
    command: 'curl "https://api.example.com/search?q=javascript&limit=10&sort=stars"',
    category: 'params',
    icon: '🔍'
  },
  {
    id: 'put-update',
    title: 'PUT 更新数据',
    description: '使用 PUT 方法更新资源',
    command: 'curl -X PUT -H "Content-Type: application/json" -d \'{"name": "Updated Name", "status": "active"}\' https://api.example.com/users/123',
    category: 'data',
    icon: '🔄'
  },
  {
    id: 'delete-resource',
    title: 'DELETE 删除资源',
    description: '删除指定的资源',
    command: 'curl -X DELETE https://api.example.com/users/123',
    category: 'basic',
    icon: '🗑️'
  },
  {
    id: 'patch-partial',
    title: 'PATCH 部分更新',
    description: '部分更新资源数据',
    command: 'curl -X PATCH -H "Content-Type: application/json" -d \'{"status": "inactive"}\' https://api.example.com/users/123',
    category: 'data',
    icon: '✏️'
  },
  {
    id: 'cookie-session',
    title: 'Cookie 会话',
    description: '发送包含 Cookie 的请求',
    command: 'curl -b "session_id=abc123; user_id=456" https://api.example.com/dashboard',
    category: 'cookies',
    icon: '🍪'
  },
  {
    id: 'follow-redirect',
    title: '跟随重定向',
    description: '自动跟随 HTTP 重定向',
    command: 'curl -L https://short.url/abc123',
    category: 'redirect',
    icon: '🔀'
  },
  {
    id: 'timeout-request',
    title: '设置超时',
    description: '设置请求超时时间',
    command: 'curl --connect-timeout 10 --max-time 30 https://slow-api.example.com/data',
    category: 'timeout',
    icon: '⏱️'
  },
  {
    id: 'insecure-ssl',
    title: '忽略 SSL 证书',
    description: '跳过 SSL 证书验证（仅用于开发环境）',
    command: 'curl -k https://self-signed.example.com/api',
    category: 'ssl',
    icon: '🔓'
  },
  {
    id: 'proxy-request',
    title: '使用代理',
    description: '通过代理服务器发送请求',
    command: 'curl -x http://proxy.example.com:8080 https://api.example.com/data',
    category: 'proxy',
    icon: '🌐'
  },
  {
    id: 'head-request',
    title: 'HEAD 请求',
    description: '只获取响应头信息',
    command: 'curl -I https://api.example.com/users',
    category: 'basic',
    icon: '📋'
  },
  {
    id: 'options-cors',
    title: 'OPTIONS 预检请求',
    description: '发送 CORS 预检请求',
    command: 'curl -X OPTIONS -H "Origin: https://myapp.com" -H "Access-Control-Request-Method: POST" https://api.example.com/data',
    category: 'cors',
    icon: '🔄'
  },
  {
    id: 'binary-download',
    title: '下载二进制文件',
    description: '下载图片或其他二进制文件',
    command: 'curl -o image.jpg https://example.com/image.jpg',
    category: 'download',
    icon: '📷'
  },
  {
    id: 'raw-data-post',
    title: '发送原始数据',
    description: '发送原始字符串数据',
    command: 'curl -X POST --data-raw "raw data content" https://api.example.com/raw',
    category: 'data',
    icon: '📄'
  },
  {
    id: 'multiple-headers',
    title: '多行请求头',
    description: '使用多行格式定义请求头',
    command: 'curl -H "Authorization: Bearer token" \\\n     -H "Content-Type: application/json" \\\n     -d \'{"key": "value"}\' \\\n     https://api.example.com/data',
    category: 'headers',
    icon: '📝'
  }
];

/**
 * 按类别分组的示例
 */
export const examplesByCategory = {
  basic: examples.filter(ex => ex.category === 'basic'),
  data: examples.filter(ex => ex.category === 'data'),
  auth: examples.filter(ex => ex.category === 'auth'),
  headers: examples.filter(ex => ex.category === 'headers'),
  upload: examples.filter(ex => ex.category === 'upload'),
  params: examples.filter(ex => ex.category === 'params'),
  cookies: examples.filter(ex => ex.category === 'cookies'),
  redirect: examples.filter(ex => ex.category === 'redirect'),
  timeout: examples.filter(ex => ex.category === 'timeout'),
  ssl: examples.filter(ex => ex.category === 'ssl'),
  proxy: examples.filter(ex => ex.category === 'proxy'),
  cors: examples.filter(ex => ex.category === 'cors'),
  download: examples.filter(ex => ex.category === 'download')
};

/**
 * 类别配置
 */
export const categories = [
  { id: 'basic', name: '基础请求', icon: '🚀', description: 'GET、POST、PUT、DELETE 等基本操作' },
  { id: 'data', name: '数据传输', icon: '📦', description: '发送 JSON、表单数据等' },
  { id: 'auth', name: '认证授权', icon: '🔐', description: 'Bearer Token、基本认证等' },
  { id: 'headers', name: '请求头', icon: '🏷️', description: '自定义请求头设置' },
  { id: 'upload', name: '文件上传', icon: '📎', description: '文件和表单上传' },
  { id: 'params', name: '查询参数', icon: '🔍', description: 'URL 参数处理' },
  { id: 'cookies', name: 'Cookie', icon: '🍪', description: 'Cookie 会话管理' },
  { id: 'redirect', name: '重定向', icon: '🔀', description: '重定向处理' },
  { id: 'timeout', name: '超时控制', icon: '⏱️', description: '连接和请求超时' },
  { id: 'ssl', name: 'SSL/TLS', icon: '🔒', description: 'SSL 证书处理' },
  { id: 'proxy', name: '代理', icon: '🌐', description: '代理服务器配置' },
  { id: 'cors', name: 'CORS', icon: '🔄', description: '跨域请求处理' },
  { id: 'download', name: '下载', icon: '📥', description: '文件下载操作' }
];

/**
 * 获取随机示例
 * @param {number} count - 返回的示例数量
 * @returns {Array} 随机示例数组
 */
export function getRandomExamples(count = 3) {
  const shuffled = [...examples].sort(() => 0.5 - Math.random());
  return shuffled.slice(0, count);
}

/**
 * 根据类别获取示例
 * @param {string} categoryId - 类别 ID
 * @returns {Array} 该类别的所有示例
 */
export function getExamplesByCategory(categoryId) {
  return examplesByCategory[categoryId] || [];
}

/**
 * 搜索示例
 * @param {string} query - 搜索关键词
 * @returns {Array} 匹配的示例
 */
export function searchExamples(query) {
  const lowerQuery = query.toLowerCase();
  return examples.filter(example =>
    example.title.toLowerCase().includes(lowerQuery) ||
    example.description.toLowerCase().includes(lowerQuery) ||
    example.command.toLowerCase().includes(lowerQuery) ||
    example.category.toLowerCase().includes(lowerQuery)
  );
}

/**
 * 获取示例统计信息
 * @returns {Object} 统计数据
 */
export function getExamplesStats() {
  return {
    total: examples.length,
    categories: Object.keys(examplesByCategory).length,
    mostPopularCategory: Object.entries(examplesByCategory)
      .sort(([,a], [,b]) => b.length - a.length)[0][0]
  };
}